<template>
  <LoadingPadrao
    v-if="tipoLoading == 1"
    tipo="circulo"
    :conteudo="fraseLoading"
    :escala="escala ? escala : '0.5'"
    :tamanho="tamanho ? tamanho : '50'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 2"
    tipo="bloco"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '36'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 3"
    tipo="simples"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '36'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 4"
    tipo="quadrado"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '50'"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <LoadingPadrao
    v-else-if="tipoLoading == 5"
    tipo="linha"
    :conteudo="fraseLoading"
    :tamanho="tamanho ? tamanho : '36'"
    numero="8"
    :classe="classe"
    :delay="delay"
    :background="background"
  />
  <div
    :style="tamanho ? `font-size: ${tamanho}px;` : ''"
    v-else-if="!tipoLoading || tipoLoading == '' || tipoLoading == 0"
    class="loading-velho"
  >
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</template>

<script>
import LoadingPadrao from "@/components/LoadingPadrao/LoadingPadrao.vue";

export default {
  name: "LoadingPadraoContainer",
  components: {
    LoadingPadrao
  },
  props: {
    background: Boolean,
    fraseLoading: Array,
    tamanho: String,
    escala: String,
    classe: String,
    delay: String,
    tipo: String
  },
  computed: {
    tipoLoading() {
      if (this.tipo) {
        return this.tipo;
      }
      return "5";
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-velho {
  font-size: 35px;
  display: flex;
  justify-content: center;
}
</style>
